/**
 * Matrix URI <-> Sigil Converter
 *
 * Converts between Matrix URI format (matrix:u/user:domain.de)
 * and Matrix sigil format (@user:domain.de).
 *
 * All inputs are validated with strict regex to prevent XSS/injection.
 * Invalid inputs return null rather than throwing.
 */

// Strict patterns to validate Matrix identifiers
const MATRIX_URI_REGEX = /^matrix:u\/([a-zA-Z0-9._=/+%-]+:[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/;
const MATRIX_SIGIL_REGEX = /^@([a-zA-Z0-9._=/+%-]+:[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/;

/**
 * Convert a Matrix URI to sigil format.
 * @param {string} uri - e.g. "matrix:u/user:domain.de"
 * @returns {string|null} e.g. "@user:domain.de", or null if invalid
 */
export function matrixUriToSigil(uri) {
  if (typeof uri !== 'string') {
    return null;
  }
  const match = uri.match(MATRIX_URI_REGEX);
  if (!match) {
    return null;
  }
  return `@${match[1]}`;
}

/**
 * Convert a Matrix sigil to URI format.
 * @param {string} sigil - e.g. "@user:domain.de"
 * @returns {string|null} e.g. "matrix:u/user:domain.de", or null if invalid
 */
export function matrixSigilToUri(sigil) {
  if (typeof sigil !== 'string') {
    return null;
  }
  const match = sigil.match(MATRIX_SIGIL_REGEX);
  if (!match) {
    return null;
  }
  return `matrix:u/${match[1]}`;
}
